<template>
  <div class="app">
    <AppHeader />
    <div class="app-body">
      <Sidebar :navItems="nav" />
      <main class="main">
        <breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside />
    </div>
    <AppFooter />
    <DxPopup :visible="IsPopup"
             :drag-enabled="false"
             :close-on-outside-click="false"
             :show-title="true"
             :showCloseButton="false"
             :width="600"
             :height="250"
             :title="featureName +' Subscription'">
      <center>ATTENTION!</center><br />
      <div style="font-size:10pt">
        {{featureName}} is not included in your mPortal subscription. If you would like to learn more about this please contact Market Scan Information Systems at <br />
        <center>
          <b>866/MKT-SCAN (866/658-7226)</b> or e-mail
          <a href="mailto:sales@marketscan.com" style="font-size:14pt">sales@marketscan.com</a>
        </center>
        <br />
        <center>
          <button id="btnClose" class="btn" @click="CloseIt" title="Close">
            <i title="OK" class="fa fa-window-close-o fa-lg"></i>
            <strong>Close</strong>
          </button>
        </center>
      </div>
    </DxPopup>
  </div>
</template>

<script>
import DxPopup from 'devextreme-vue/popup'
import EventBus from '../components/EventBus/event-bus'

import nav from '../_nav'
import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'

export default {
  name: 'full',
  components: {
    DxPopup,
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb
  },
  data () {
    return {
      // nav: nav.items
      nav: nav.GetItems(),
      IsPopup: false,
      featureName: 'mDesking'
    }
  },
  mounted () {
    let self = this
    EventBus.$on('FeatureSubscriptionEvent', self.HandleFeatureSubscriptionEvent)
  },
  beforeDestroy () {
    let self = this
    EventBus.$off('FeatureSubscriptionEvent', self.HandleFeatureSubscriptionEvent)
  },
  methods: {
    HandleFeatureSubscriptionEvent (arg) {
      let self = this
      self.IsPopup = true
      self.featureName = arg
    },
    CloseIt () {
      let self = this
      self.IsPopup = false
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Full.vue